/*
 * @Author: princemwang
 * @Date: 2023-02-01 14:30:41
 * @LastEditors:
 * @LastEditTime: 2023-02-08 17:13:50
 */
import { Modal, Button } from '@tencent/tea-component';
import { IS_GROUP } from '@/utils';

const RegisterModal = ({ visible, text, openPage }: { visible: boolean; text: string; openPage: () => void }) => {
  return (
    <Modal visible={visible} caption="" disableCloseIcon size="l">
      <Modal.Body
        style={{
          fontWeight: '700',
          fontSize: '14px',
          fontFamily: 'PingFang SC-medium',
          whiteSpace: 'pre-wrap',
        }}
      >
        {`You have registered. \nThe webcast will start at ${text}`}
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={openPage}>
          {IS_GROUP ? 'Back to Investors page' : 'Back to Investors Page'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default RegisterModal;
